import { XERO_ORGANISATION_FETCHED } from 'utils/constants'
import * as A from 'actions/oauth-sign-in';

export default (state = null, action) => {
  switch (action.type) {
    case XERO_ORGANISATION_FETCHED:
      return action.data.organisation;
    case A.OAUTH_SIGN_IN_COMPLETE:
      return null; // clear organisation after oauth sign in
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/organisation.js